var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0013 0.916748C16.5702 0.916748 21.0846 5.43121 21.0846 11.0001C21.0846 16.569 16.5702 21.0834 11.0013 21.0834C5.43243 21.0834 0.917969 16.569 0.917969 11.0001C0.917969 5.43121 5.43243 0.916748 11.0013 0.916748ZM11.0013 2.75008C6.44495 2.75008 2.7513 6.44373 2.7513 11.0001C2.7513 15.5564 6.44495 19.2501 11.0013 19.2501C15.5577 19.2501 19.2513 15.5564 19.2513 11.0001C19.2513 6.44373 15.5577 2.75008 11.0013 2.75008ZM11.0013 4.58341C11.5076 4.58341 11.918 4.99382 11.918 5.50008V10.5518L15.6891 13.4848C16.0887 13.7957 16.1607 14.3716 15.8499 14.7712C15.5391 15.1708 14.9631 15.2428 14.5635 14.932L10.4385 11.7237C10.2152 11.55 10.0846 11.283 10.0846 11.0001V5.50008C10.0846 4.99382 10.495 4.58341 11.0013 4.58341Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsDuration);
export default __webpack_public_path__ + "static/media/DetailsDuration.501f7d9e4caf5ac45aab6b80f0fdc117.svg";
export { ForwardRef as ReactComponent };